import { memo, useState } from 'react';

import { CheckoutConfirmationContactOrganizerModal } from 'src/pages/Checkout/components/ContactOrganizer/_modal';
import { UiButton } from 'src/components/UI/Button';
import { useTHelper } from 'src/utils/i18n';
import { Enums } from 'src/models/enums';

type Props = {
  permanenturl: string;
};

export const CheckoutConfirmationContactOrganizer = memo<Props>(({ permanenturl }) => {
  const tHelper = useTHelper('checkout.confirmation.contactOrganizer');

  const [showModal, setShowModal] = useState(false);

  if (window.DonorSupportTypeID !== Enums.campaigns.DonorSupportType.OrganizerButton) {
    return null;
  }

  return (
    <>
      <UiButton
        id="ContactOrganizerButton"
        primary
        className="btn-rounded btn-contact-organizer"
        onClick={() => setShowModal(true)}
      >
        <i className="material-icons">mail</i> <span className="hidden-xs">{tHelper('contactOrganizer')}</span>
      </UiButton>

      {showModal && (
        <CheckoutConfirmationContactOrganizerModal permanenturl={permanenturl} onClose={() => setShowModal(false)} />
      )}
    </>
  );
});
